// extracted by mini-css-extract-plugin
export default {"wallet":"WalletButton_wallet__oGUBr"};